function distance (num) {
  if (typeof (num) !== 'number') return ''
  return Math.round(num * 10) / 10 + ' mi.'
}

export default distance
